export default __webpack_public_path__ + "static/media/add-full-light.fde5067b.svg";